import { styled, Box, BoxProps } from '@mui/material';
import { BadgeColors } from './PulsingBadge.types';

export const CountBadgeContainer = styled(Box)({
  position: 'relative'
});

export const CountBadgeDot = styled(Box, {
  shouldForwardProp: (prop: string) => prop !== 'color' && prop !== 'offset'
})<BoxProps & { color: BadgeColors; offset: number }>(({ theme, color, offset }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  position: 'absolute',
  top: -12,
  right: offset,
  minWidth: 18,
  height: 18,
  borderRadius: '50%',
  fontSize: '0.7rem',
  fontWeight: 500,
  backgroundColor: theme.palette[color].main,
  color: theme.palette[color].contrastText
}));
